const MODULE_NAME = 'JobsModule';

export const JOBS_GET_FOLDERS = `${MODULE_NAME}/JOBS_GET_FOLDERS`;
export const JOBS_GET_JOB = `${MODULE_NAME}/JOBS_GET_JOB`;
export const UPDATE_JOB_REPORT = `${MODULE_NAME}/UPDATE_JOB_REPORT`;
export const GET_JOB = `${MODULE_NAME}/GET_JOB`;
